import { PropsWithChildren, createContext } from "react";

import { Project } from "@/api";

type ProjectContextType = {
  project: Project;
};
export const ProjectContext = createContext<ProjectContextType>(
  {} as unknown as ProjectContextType
);

interface ProjectProviderProps {
  project: Project;
}

export function ProjectProvider({ project, children }: PropsWithChildren<ProjectProviderProps>) {
  return <ProjectContext.Provider value={{ project }}>{children}</ProjectContext.Provider>;
}
